interface ProjectHeroThumbProps {
  thumbUrl: string | null
  /** Stable id for fallback color generation when no hero. */
  fallbackSeed: string
  alt?: string
}

/**
 * Phase 8 — small ratio-preserving hero preview rendered to the left of project titles on the
 * dashboard Doing tab, Profile project list, and Subscriptions feed. Falls back to a deterministic
 * styled-empty block when the project has no hero.
 */
export const ProjectHeroThumb = ({ thumbUrl, fallbackSeed, alt }: ProjectHeroThumbProps) => {
  if (thumbUrl) {
    return (
      <img
        src={thumbUrl}
        alt={alt ?? ''}
        className="h-8 w-14 flex-none rounded-sm object-cover"
        loading="lazy"
      />
    )
  }
  return (
    <div
      aria-hidden="true"
      style={{ backgroundColor: fallbackColor(fallbackSeed) }}
      className="h-8 w-14 flex-none rounded-sm"
    />
  )
}

const fallbackColor = (seed: string): string => {
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0
  }
  const hue = Math.abs(hash) % 360
  return `hsl(${hue}, 30%, 88%)`
}
